export const CATEGORY_LABELS = {
    news: "News",
    "personal-finance": "Personal Finance",
    "debt-management": "Debt Management",
    "small-business": "Small Business",
    investing: "Investing",
    markets: "Markets",
};

export const CATEGORIES = [
    "news",
    "personal-finance",
    "debt-management",
    "small-business",
    "investing",
    "markets",
];

export const SUBCATEGORY_LABELS = {
    banking: "Banking",
    "credit-cards": "Credit Cards",
    loans: "Loans",
    mortgage: "Mortgage",
    retirement: "Retirement",
    taxes: "Taxes",
};

export const SUBCATEGORIES = [
    "banking",
    "credit-cards",
    "loans",
    "mortgage",
    "retirement",
    "taxes",
];

// Sample market data for the ticker bar (illustrative, not live market data).
export const TICKER_SYMBOLS = [
    { symbol: "S&P 500", value: "5,431.60", change: "+0.42%", up: true },
    { symbol: "NASDAQ", value: "17,689.36", change: "+0.61%", up: true },
    { symbol: "DOW", value: "38,589.16", change: "-0.15%", up: false },
    { symbol: "FTSE 100", value: "8,146.86", change: "+0.23%", up: true },
    { symbol: "GOLD", value: "2,348.40", change: "-0.31%", up: false },
    { symbol: "BRENT", value: "82.62", change: "+1.04%", up: true },
    { symbol: "BTC", value: "66,214.00", change: "+2.18%", up: true },
    { symbol: "ETH", value: "3,512.77", change: "+1.42%", up: true },
    { symbol: "EUR/USD", value: "1.0742", change: "-0.08%", up: false },
    { symbol: "GBP/USD", value: "1.2761", change: "+0.11%", up: true },
    { symbol: "US 10Y", value: "4.281%", change: "+0.03", up: true },
    { symbol: "VIX", value: "12.66", change: "-1.24%", up: false },
];
